import { Delete } from '@mui/icons-material';
import { Box, Icon, IconButton } from '@mui/material';
import { FC, useRef, useState } from 'react';
import { FileDrop } from 'react-file-drop';

export type TStep3Props = {
	onFileChange: (file: File | null) => void;
	// file: File | null;
	name: string | null;
	size: number | null;
};
export const Step3: FC<TStep3Props> = ({ onFileChange, name, size }) => {
	// const file = null;
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	const onFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { files } = event.target;
		if (files && files.length > 0) {
			onFileChange(files[0]);
		}
	};

	const onTargetClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	const onDrop = (files: FileList | null, event: React.DragEvent<HTMLDivElement>) => {
		if (files && files.length > 0) {
			onFileChange(files[0]);
			event.preventDefault();
			event.stopPropagation();
		}
	};

	return (
		<Box>
			{!name && (
				<FileDrop onDrop={onDrop} onTargetClick={onTargetClick}>
					Drag Files or Click to Browse
					<div style={{ fontSize: '.8rem', marginTop: '15px' }}>
						Please, attach file that proves correction reason.
						<br />
						If you need to attach several files, please,
						<br />
						put them in the zip file and attach as a single attachment.
						<br />
						<b>File size should not exceed 10 Mb.</b>
					</div>
				</FileDrop>
			)}
			{size && (
				<Box>
					<Box
						sx={{
							fontSize: '1.2rem',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							color: 'primary.main',
							mt: 8,
						}}
					>
						<Box color={size > 10_000_000 ? 'error.main' : 'auto'}>
							<b>{name}</b>,{' '}
							{size > 1_000_000 ? (
								<span>{(size / 1_000_000).toFixed(3)} MB </span>
							) : size > 1000 ? (
								<span>{(size / 1000).toFixed(3)} KB </span>
							) : (
								<span>{size} B</span>
							)}
						</Box>
						<IconButton
							onClick={() => {
								onFileChange(null);
							}}
							color="primary"
						>
							<Delete />
						</IconButton>
					</Box>
					{size > 10_000_000 && (
						<Box style={{ fontSize: '.9rem', marginTop: '10px' }} color="error.main">
							<b>File size should not exceed 10 MB!</b>
						</Box>
					)}
				</Box>
			)}
			<input
				ref={fileInputRef}
				type="file"
				accept=".csv,.docx,.xlsx,.zip,.pdf,image/*"
				onChange={onFileInputChange}
				style={{ display: 'none' }}
			/>
			{/* <Button
				onClick={() => {
					if (fileInputRef?.current) fileInputRef.current.click();
				}}
			>
				Click to upload
			</Button> */}
		</Box>
	);
};
